import { Head, Link, usePage } from "@inertiajs/react"
import { Button } from "@/components/ui/button"
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table"
import { format } from "date-fns"
import { fr } from "date-fns/locale"

interface User {
  id: number
  username: string
  admin: boolean
  created_at: string
}

interface IndexProps {
  users: User[]
}

export default function Index({ users }: IndexProps) {
  const { auth } = usePage<{ auth: { user: { id: number } } }>().props

  return (
    <div className="container mx-auto py-8">
      <Head title="Gestion des utilisateurs" />
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-3xl font-bold tracking-tight">Utilisateurs</h1>
        <Button asChild>
          <Link href="/admin/users/new">Nouvel Utilisateur</Link>
        </Button>
      </div>

      <div className="border rounded-md">
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>Nom d'utilisateur</TableHead>
              <TableHead>Rôle</TableHead>
              <TableHead>Date de création</TableHead>
              <TableHead className="text-right">Actions</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {users.map((user) => (
              <TableRow key={user.id}>
                <TableCell className="font-medium">{user.username}</TableCell>
                <TableCell>
                  {user.admin ? (
                    <span className="inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 border-transparent bg-primary text-primary-foreground hover:bg-primary/80">
                      Admin
                    </span>
                  ) : (
                    <span className="inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 border-transparent bg-secondary text-secondary-foreground hover:bg-secondary/80">
                      Utilisateur
                    </span>
                  )}
                </TableCell>
                <TableCell>
                  {format(new Date(user.created_at), "d MMMM yyyy", { locale: fr })}
                </TableCell>
                <TableCell className="text-right space-x-2">
                  <Button variant="ghost" size="sm" asChild>
                    <Link href={`/admin/users/${user.id}/edit`}>Modifier</Link>
                  </Button>
                  {user.id !== auth.user.id && (
                    <Link
                      href={`/admin/users/${user.id}`}
                      method="delete"
                      as="button"
                      className="inline-flex items-center justify-center rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 hover:bg-accent hover:text-accent-foreground h-9 px-3 text-destructive hover:text-destructive"
                    >
                      Supprimer
                    </Link>
                  )}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
    </div>
  )
}
